module.exports = __webpack_public_path__ + "static/media/people.25e0a902.svg";